import {caseService} from "../../application";
import {
  CASE_FETCH_BY_ID,
  CASE_FETCHED_BY_ID_SUCCESS,
  CASE_FETCHED_BY_ID_FAILED
} from "../mutations/available";
import api from "../../api";

export async function fetchCaseByIdIfRequired({commit, dispatch, state}, caseId) {
  if (state.caseInfos[caseId]) {
    return state.caseInfos[caseId]
  }

  commit(CASE_FETCH_BY_ID, {caseId});

  return caseService
    .getCase({caseId})
    .then(response => {
      commit(CASE_FETCHED_BY_ID_SUCCESS, {caseId: caseId, response: response})
    })
    .catch(e => {
      commit(CASE_FETCHED_BY_ID_FAILED, {caseId: caseId, error: e});
      throw e
    })
}

export async function caseChangeCaseClient({commit, dispatch}, {caseId, newClientId}) {
  return api
    .changeCaseClient(caseId, newClientId, false)
}

export function getCaseSlideStainForService({dispatch}, request) {
  return caseService.getCaseSlideStainForService(request)
    .then(response => {
      return response
    })
}



// WEBPACK FOOTER //
// ./src/store/actions/case.js